import type { EditAssetWorkflowOptions } from '../../types';

export const editReturnsSettings: EditAssetWorkflowOptions = {
  workflowKey: 'editReturnsSetting',
  workflowType: 'editAssetWorkflow',
  assetType: 'returnsSettings',
  workflowIndex: 2,
  workflowName: 'Edit Returns Settings',
  workflowDescription: `Edit information about your return setting`,
  workflowAssets: ['address', 'contact', 'returnsSettings'],
  workflowStepOptions: [
    {
      workflowStepKey: 'partnerProvidedId',
      workflowStepNavigationName: 'Return ID Alias',
      optional: true,
      workflowComponent: {
        workflowComponentType: 'textEntry',
        prompt: 'Enter a unique identifier for this return',
        description: 'This is optional but will allow you to more easily reference this return in API calls.',
        help: '',
      },
      includeInDefaultAssetNameRules: {
        includeInDefaultAssetName: true,
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'partnerProvidedId',
      },
    },
    {
      workflowStepKey: 'returnToAddressId',
      workflowStepNavigationName: 'Address',
      workflowComponent: {
        workflowComponentType: 'addressEntry',
        prompt: 'What address do you use for returns?',
        description: `Select an existing address or create a new one`,
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'link',
        linkAssetTypeOverride: 'returnToAddress',
        linkAssetType: 'address',
      },
    },
    {
      workflowStepKey: 'returnToContactId',
      workflowStepNavigationName: 'Contact',
      workflowComponent: {
        workflowComponentType: 'contactEntry',
        prompt: 'What contact do you use for returns?',
        description: `Select an existing contact or create a new one`,
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'link',
        linkAssetTypeOverride: 'returnToContactInfo',
        linkAssetType: 'contact',
      },
    },
    // using name component for consistency
    // but we get nothing from it
    {
      workflowStepKey: 'name',
      workflowStepNavigationName: 'Name',
      excludeFromNavigation: false,
      refreshAssetsOnStepCompletion: true,
      workflowComponent: {
        workflowComponentType: 'assetNameEntry',
        prompt: 'How will you refer to these return settings?',
        description: 'Enter a name for your settings',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'name',
      },
    },
    {
      workflowStepKey: 'description',
      workflowStepNavigationName: 'Description',
      excludeFromNavigation: false,
      refreshAssetsOnStepCompletion: true,
      workflowComponent: {
        workflowComponentType: 'textEntry',
        prompt: 'Add a description for these return settings?',
        description: 'Add a description to help you refer back to these settings',
        help: '',
        rows: 4,
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'description',
      },
    },
    //TODO: find out if we need this
    // {
    //   workflowStepKey: 'tenantSelect',
    //   workflowStepNavigationName: 'Tenant Select',
    //   workflowComponent: {
    //     assetType: 'tenant',
    //     workflowComponentType: 'tenantSelect',
    //     prompt: 'Do these return settings belong to a specific tenant?',
    //     description: '',
    //     help: 'Specifying a tenant will allow you to more easily filter you various configuration pieces',
    //     optional: true,
    //   },
    //   workflowStepConditionalMatcher: [
    //     {
    //       assetType: 'tenant',
    //       schema: { type: 'array', minItems: 1 },
    //     },
    //   ],
    //   workflowStateToAssetMapping: {
    //     mappingType: 'link',
    //     linkAssetType: 'tenant',
    //     linkType: 'Tenant',
    //   },
    // },
    {
      workflowStepKey: 'summary',
      workflowStepNavigationName: 'Configuration Summary',
      workflowComponent: {
        workflowComponentType: 'workflowSummary',
        title: 'Edit Returns Setting Summary',
        description: 'The following Return Setting will be created.  Please review your selections.',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'ignore',
      },
    },
  ],
};
